import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminAiUsage } from '../../services/getAdminAiUsage.service';

export const loadAdminAiUsage = createAsyncThunk(
  'adminAi/loadAdminAiUsage',
  async (yearMonth, { rejectWithValue }) => {
    try {
      return await getAdminAiUsage(yearMonth);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load AI usage');
    }
  }
);
